var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLocationss(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.94 11A8.994 8.994 0 0013 3.06V1h-2v2.06A8.994 8.994 0 003.06 11H1v2h2.06A8.994 8.994 0 0011 20.94V23h2v-2.06A8.994 8.994 0 0020.94 13H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIwLjk0IDExQzIwLjQ4IDYuODMgMTcuMTcgMy41MiAxMyAzLjA2VjFIMTFWMy4wNkM2LjgzIDMuNTIgMy41MiA2LjgzIDMuMDYgMTFIMVYxM0gzLjA2QzMuNTIgMTcuMTcgNi44MyAyMC40OCAxMSAyMC45NFYyM0gxM1YyMC45NEMxNy4xNyAyMC40OCAyMC40OCAxNy4xNyAyMC45NCAxM0gyM1YxMUgyMC45NFpNMTIgMTlDOC4xMyAxOSA1IDE1Ljg3IDUgMTJDNSA4LjEzIDguMTMgNSAxMiA1QzE1Ljg3IDUgMTkgOC4xMyAxOSAxMkMxOSAxNS44NyAxNS44NyAxOSAxMiAxOVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";
export { SvgLocationss as ReactComponent };